import { render, staticRenderFns } from "./PlanCard.vue?vue&type=template&id=cfea65fa&"
import script from "./PlanCard.vue?vue&type=script&lang=ts&"
export * from "./PlanCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports